"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QuoteLayout = void 0;
var _mui = require("@ori-ui/mui");
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../utils");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const QuoteLayout = (param)=>{
    let { banner, debug, modulePosition, className } = param;
    var _modules_;
    const { getTestId } = (0, _testidGenerator.default)();
    const { modules, layout } = banner;
    if (!(modules === null || modules === void 0 ? void 0 : (_modules_ = modules[0]) === null || _modules_ === void 0 ? void 0 : _modules_.content)) {
        return (0, _utils.getModulesContentError)({
            debug,
            layout,
            modulePosition
        });
    }
    const { backgroundStorybookColor, content } = modules[0];
    const { title, titleStorybookColor, titleSize } = content;
    const variantMapping = {
        H5: 'h5',
        H6: 'h6'
    };
    const variant = variantMapping[titleSize];
    const mappedBackgroundColor = (0, _presentationUtils.mapBackendColorToTheme)({
        backendColor: backgroundStorybookColor,
        theme: _mui.theme
    });
    const mappedTitleColor = (0, _presentationUtils.mapBackendColorToTheme)({
        backendColor: titleStorybookColor,
        fallBackColor: _mui.theme.palette.common.black,
        theme: _mui.theme
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.Quote),
        backgroundColor: mappedBackgroundColor,
        titleColor: mappedTitleColor,
        className: className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Text, {
            variant: variant,
            component: "h2",
            textAlign: "center",
            children: title
        })
    });
};
exports.QuoteLayout = QuoteLayout;
